import angular from 'angular'

angular.module('nominas.nomina')
  .service('NominasNominaMovimientosEmpleados', NominasNominaMovimientosEmpleados)

function NominasNominaMovimientosEmpleados($http) {
  this.get = _get

  function _get(idEmpresa, idNomina) {
    return $http.get('kendu/nominas/nomina/movimientos/empleados', {
      params: {idEmpresa: idEmpresa, idNomina: idNomina},
      schema: NominasNominaMovimientosEmpleadosSchema,
      cache: 'nominas',
    })
  }
}

let NominasNominaMovimientosEmpleadosSchema = {
  status: 'boolean',
  comision_porcentaje: 'number',
  config: {
    fecha_alta: 'date',
    fecha_baja: 'date',
    id_regimen_fiscal: 'number',
    salario_diario: 'number',
  },
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/services/Nomina/Movimientos/Empleados.js